import { Avatar, Box, Stack } from "@mui/material";
import { CustomTextView } from "../../../component/CustomTextView";
import { COLOR_LIGHT_GRAY, COLOR_WHITE } from "../../../../data/colors/Colors";
import { useEffect, useState } from "react";
import { UserInfoViewModel } from "./UserInfoViewModel";
import { providePlayerGetCurrentInfoUseCase } from "../../../di/UseCasesModule";
import { useTranslation } from "react-i18next";
import { Player } from "../../../../domain/model/User";
import { useNavigation } from "react-router-dom";
import { STORAGE_KEYS } from "../../../../data/constant/Constants";

export function UserAvatarView({
  onFetchPlayer,
}: {
  onFetchPlayer: (p: Player) => void;
}) {
  const viewModel = UserInfoViewModel(providePlayerGetCurrentInfoUseCase());
  const player = viewModel.player;

  const { t } = useTranslation();

  useEffect(() => {
    if (player) onFetchPlayer(player);
  }, [player]);

  useEffect(() => {
  
    window.addEventListener(STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN, viewModel.getCurrentInfo)
  
    return () => {
      window.removeEventListener(STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN, viewModel.getCurrentInfo)
    }
  }, [])

  return (
    <Stack alignItems={"center"} width={"100%"} >
      <Avatar
        sx={{ width: 100, height: 100, background: "rgba(135,40,77,0.35)" }}
        src={player?.profileImage}
      />

      <Box height={6} />
      <CustomTextView
        text={player ? player.name : t("loading")}
        variant="subtitle1"
        textColor={COLOR_WHITE}
        fontWeight="bold"
        textAlign="center"
      />
      <CustomTextView
        text={player ? player.user?.email : t("loading")}
        variant="subtitle2"
        textColor={COLOR_LIGHT_GRAY}
        textAlign="center"
      />
    </Stack>
  );
}
